import React from 'react';
import { IconStatusInformationOnlight } from '@piggybank/core';
export const ErrorPageIcon = () => {
  return <IconStatusInformationOnlight width="3em" />;
};
